"use client"
import React from 'react';
import { DateTime } from 'luxon';
import { Prisma } from '@prisma/client';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { formatPrix } from '@/functions/global';
import reactStringReplace from 'react-string-replace';

type NextVentesModalProps = {
    tgi?: Prisma.TgiGetPayload<{}>;
    ventes: any[];
};

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#fff',
        margin: 10,
        width: '98%',
        fontFamily: 'Open Sans',
    },
    titleContainer: {
        flexDirection: 'row',
        marginTop: 24,
    },
    logo: {
        width: 100,
        height: 50,
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    theader: {
        marginTop: 20,
        fontSize: 9,
        fontWeight: 600,
        lineHeight: 1.5,
        padding: 4,
        height: 'auto',
        backgroundColor: '#DEDEDE',
        width: '14.5%',
        flex: 1,
        textAlign: 'left',
        wordBreak: 'break-all',
    },
    tbody: {
        fontSize: 9,
        lineHeight: 1.5,
        flex: 1,
        padding: 7,
        height: 'auto',
        width: '14.5%',
        margin: 0,
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderBottomWidth: 1,
        borderBottomColor: '#DEDEDE',
        textAlign: 'left',
    },
    spaceBetween: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    reportTitle: {
        fontSize: 18,
        color: '#555',
        width: '100%',
        wordBreak: 'break-word',
        textAlign: 'center',
    },
    textBold: { fontWeight: 600 },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 12,
        color: 'grey',
    },
});

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
    ],
});

const NextVentesPdf = ({ tgi, ventes }: NextVentesModalProps) => {
    return (
        <Document>
            <Page size="A4" style={styles.page} orientation="landscape" wrap>
                <View fixed>
                    {/* eslint-disable-next-line jsx-a11y/alt-text */}
                    <Image style={{ width: 200, height: 50 }} src="/img/logo.jpg" />
                </View>
                <View style={styles.titleContainer} fixed>
                    <View style={styles.spaceBetween}>
                        <Text style={styles.reportTitle}>{`Vente aux enchères ${tgi?.nom}`}</Text>
                    </View>
                </View>
                <View style={{ width: '98%', flexDirection: 'row', marginTop: 10 }} fixed>
                    <View style={styles.theader}>
                        <Text>Avocat</Text>
                    </View>
                    <View style={styles.theader}>
                        <Text>D&eacute;signation</Text>
                    </View>
                    <View style={styles.theader}>
                        <Text>Montant de la vente + mention</Text>
                    </View>
                    <View style={styles.theader}>
                        <Text>Adresse de la vente</Text>
                    </View>
                    <View style={styles.theader}>
                        <Text>Date de la vente</Text>
                    </View>
                    <View style={styles.theader}>
                        <Text>Montant d&apos;adjudication</Text>
                    </View>
                    <View style={styles.theader}>
                        <Text>Avocat adjudicataire</Text>
                    </View>
                </View>
                <View style={{ width: '98%', flexDirection: 'column' }}>
                    {ventes.map((vente, index) => (
                        <React.Fragment key={index}>
                            <View style={{ width: '100%', flexDirection: 'row' }} wrap={false}>
                                <View style={styles.tbody}>
                                    <Text style={styles.textBold}>{vente.avocat.nom}</Text>
                                    <Text>{vente.avocat?.tel.match(/.{1,2}/g)?.join(' ')}</Text>
                                </View>
                                <View style={styles.tbody}>
                                    <Text>{vente.titre} </Text>
                                </View>
                                <View style={styles.tbody}>
                                    <Text style={styles.textBold}>
                                        {vente.lots && vente.lots.length > 1 ? (
                                            <>LOTS MULTIPLES</>
                                        ) : (
                                            <>{reactStringReplace(formatPrix(vente.prix), '\u202F', () => '\u00A0')}</>
                                        )}
                                    </Text>
                                </View>
                                <View style={styles.tbody}>
                                    <Text>{`${vente.adresse} ${vente.codePostal} ${vente.ville}`}</Text>
                                </View>
                                <View style={styles.tbody}>
                                    <Text>
                                        {DateTime.fromISO(vente.dateVente?.toISOString()!, { setZone: true, zone: 'Europe/Paris' })
                                            .setLocale('fr')
                                            .toLocaleString(DateTime.DATE_HUGE) +
                                            ' à ' +
                                            DateTime.fromISO(vente.dateVente?.toISOString()!, { setZone: true, zone: 'Europe/Paris' }).toFormat("HH'h'mm")}
                                    </Text>
                                </View>
                                <View style={styles.tbody}>
                                    <Text>&nbsp;</Text>
                                </View>
                                <View style={styles.tbody}>
                                    <Text>&nbsp;</Text>
                                </View>
                            </View>
                        </React.Fragment>
                    ))}
                </View>
                <Text style={styles.footer} render={({ pageNumber, totalPages }) => `Page ${pageNumber} / ${totalPages}`} fixed />
            </Page>
        </Document>
    );
};

export default NextVentesPdf;